import { apiRequest} from './index'

export const createSellerRequest = (seller) => {
  return apiRequest(
    `/admin/sellers`,
    {
      method: 'POST',
      body: JSON.stringify(seller)
    },
    true
  )
}
export const getSellersRequest = (filters = {}) => {
  const {
    page=0,
    limit=0,
    search='',
    brokerId=''
  } = filters;

  return apiRequest(
    `/admin/sellers?page=${page}&limit=${limit}&search=${search}&brokerId=${brokerId}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getSellerRequest = (id) => {
  return apiRequest(
    `/admin/sellers/${id}`,
    {
      method: 'GET'
    },
    true
  )
}

export const updateSellerRequest = (seller) => {
  return apiRequest(
    `/admin/sellers/${seller._id}`,
    {
			method: 'PUT',
			body: JSON.stringify(seller)
    },
    true
  )
}

export const deleteSellerRequest = (id) => {
  return apiRequest(
    `/admin/sellers/${id}`,
    {
			method: 'DELETE'
    },
    true
  )
}